import { Moon, Sun } from 'lucide-react';
import type { ResolvedTheme } from './theme';

export function AotProductLockup({
  compact = false,
  tagline = false,
}: {
  compact?: boolean;
  tagline?: boolean;
}) {
  return (
    <div className={`aot-product-lockup ${compact ? 'compact' : ''}`}>
      <span className="aot-logo-field">
        <img src="/brand/aot-mark.png" alt="AOT IT Solutions Inc." />
      </span>
      <span className="aot-product-name">
        <strong>OpsAI</strong>
        {!compact && <small>Managed operations</small>}
        {tagline && <em>Operational clarity, delivered.</em>}
      </span>
    </div>
  );
}

export function ThemeQuickToggle({
  resolvedTheme,
  onToggle,
}: {
  resolvedTheme: ResolvedTheme;
  onToggle: () => void;
}) {
  const target = resolvedTheme === 'dark' ? 'light' : 'dark';
  return (
    <button
      className="icon-button theme-quick-toggle"
      aria-label={`Switch to ${target} theme`}
      title={`Switch to ${target} theme`}
      onClick={onToggle}
    >
      {resolvedTheme === 'dark' ? (
        <Sun size={17} aria-hidden="true" />
      ) : (
        <Moon size={17} aria-hidden="true" />
      )}
    </button>
  );
}
